module.exports = __webpack_public_path__ + "img/snow-pattern.54d393cb.jpg";